<section aria-labelledby="modalHeaderId" class="modal-template">
  @if (modalHeader) {
    <header
      class="modal-template-header">
      @if (!isHeaderTemplateRef) {
        <h1 id="modalHeaderId" class="modal-template-header-text h2" tabindex="-1"
          [innerHTML]="modalHeader">
        </h1>
      } @else {
        <ng-container [ngTemplateOutlet]="modalHeaderRef" class="modal-template-header-text"></ng-container>
      }
      @if (showCloseX) {
        <zbp-button-component
          [iconName]="zbpIconNames.x_cross"
          class="x_cross control-button"
          (clickHandler)="dismiss()"
          [ariaLabel]="'Close Modal'"
          theme="icon">
        </zbp-button-component>
      }
    </header>
  }
  @if (bodyContent) {
    <div
      class="modal-template-body-content"
      [class.is-scrollable]="isScrollable">
      <ng-container [ngTemplateOutlet]="bodyContent"></ng-container>
    </div>
  }
  @if (footerContent) {
    <footer class="modal-template-footer-content">
      <div class="modal-template-footer-content-left">
        <ng-container [ngTemplateOutlet]="footerLeftContent"></ng-container>
      </div>
      <div class="modal-template-footer-content-right">
        <ng-container [ngTemplateOutlet]="footerContent"></ng-container>
      </div>
    </footer>
  } @else if (footerContentFull) {
    <footer class="modal-template-footer-content-full">
      <div class="modal-template-footer-content-full-template">
        <ng-container [ngTemplateOutlet]="footerContentFull"></ng-container>
      </div>
    </footer>
  }
</section>
